/**
 * Step configuration for the GettingStarted onboarding checklist.
 * Extracted to a separate file so GettingStarted.jsx only exports a component
 * (required by react-refresh/only-export-components).
 */

export function getSteps({ onNew, onOpen, onNavigate }) {
  return [
    {
      id: "create-project",
      title: "Create your first project",
      why: "Baulit organizes everything — tasks, budget, team — around your active projects.",
      actionLabel: "New Project",
      action: () => onNew(),
      detectComplete: (projects) => projects.length > 0,
      payoff: (projects) => {
        const count = projects.length;
        return `${count} project${count !== 1 ? "s" : ""} created`;
      },
    },
    {
      id: "add-tasks",
      title: "Add tasks or generate from specs",
      why: "Your task list becomes your schedule, budget tracker, and team assignment board.",
      actionLabel: "Open Tasks",
      action: (project) => onOpen(project.id),
      detectComplete: (projects) => projects.some(p => (p.tasks || []).filter(t => !t.isPhaseHeader).length > 0),
      payoff: (projects) => {
        let totalTasks = 0;
        let phaseCount = 0;
        for (const p of projects) {
          for (const t of (p.tasks || [])) {
            if (t.isPhaseHeader) phaseCount++;
            else totalTasks++;
          }
        }
        if (phaseCount > 0) return `${totalTasks} tasks across ${phaseCount} phases`;
        return `${totalTasks} task${totalTasks !== 1 ? "s" : ""} added`;
      },
    },
    {
      id: "link-dependencies",
      title: "Link task dependencies",
      why: "Dependencies unlock your critical path — Baulit will flag which tasks control your completion date.",
      actionLabel: "Open Tasks",
      action: (project) => onNavigate("open-project", project.id, "tasks"),
      detectComplete: (projects) => projects.some(p =>
        (p.tasks || []).some(t => t.predecessors && t.predecessors.length > 0)
      ),
      payoff: (projects) => {
        let depCount = 0;
        for (const p of projects) {
          for (const t of (p.tasks || [])) {
            if (t.predecessors) depCount += t.predecessors.length;
          }
        }
        return `${depCount} dependenc${depCount !== 1 ? "ies" : "y"} linked — critical path active`;
      },
    },
    {
      id: "invite-team",
      title: "Invite a team member",
      why: "Contractors see their assignments and can update status from their own dashboard.",
      actionLabel: "Manage Team",
      action: (project) => onNavigate("open-project", project.id, "team"),
      detectComplete: (projects) => projects.some(p =>
        (p.teamMembers || []).length > 1
      ),
      payoff: () => "Team member invited",
    },
  ];
}
